// Check if two values are equal
export default function (first, second, options) {
  if (first !== undefined && second !== undefined && first.includes(second)) {
    return options.fn(this);
  }
  return options.inverse(this);
}
